import * as React from 'react';
import { SiteVariablesPrepared } from "@fluentui/react-northstar";
import { IChartData } from "../chart-types";
import BarChart from "./bar";

export const BarStackedChart = ({
	title,
	data,
	siteVariables,
	theme,
}: {
	title: string;
	data: IChartData;
	siteVariables: SiteVariablesPrepared;
	theme?: string;
}) => (
	<BarChart
		{...{
			title,
			data,
			siteVariables,
			stacked: true,
			theme: theme,
		}}
	/>
);
